import { loadStripe } from '@stripe/stripe-js';

const stripeLoader = loadStripe(process.env.VUE_APP_STRIPE_KEY);

export default () => {
	return stripeLoader;
};
